import React, { useState } from 'react';
import { Trans, useTranslation } from 'react-i18next';
import moment from 'moment';
import * as Styles from './Header.style';
import { navLinks } from 'utils/nav-links-util';
import { Icon } from 'semantic-ui-react';
import { UNAUTHORIZE_USER } from 'components/sign-in/queries';
import { SEARCH } from 'components/support/queries';
import { useMutation } from 'react-query';
import { Link } from 'react-router-dom';
import { useMediaQuery } from '@mui/material';
import { H6, P } from 'utils/resuable-css';
import { CustomHeader } from '@sidraaabdullah/test-shared-library';
import { languageArray } from 'constants/language';

const Header = (props) => {
  const { isAppDrawerOpen, version, releasedDate, username, onAppDrawerToggle, queryClient } = props;
  const { t, i18n } = useTranslation();
  let defaultLang = i18n.language === 'en-US' ? 'en' : i18n.language;
  const [language, setLanguage] = useState(defaultLang);
  const [search, setSearch] = useState('');
  const [searchResult, setSearchResult] = useState({});
  const { mutate: searhResult } = useMutation(SEARCH);
  const desktopSize = useMediaQuery('(max-width:1440px)');

  const handleChangeSearch = async (text) => {
    setSearch(text);
    await searhResult(
      {
        searchResult: text,
      },
      {
        onSuccess: (e) => {
          setSearchResult(e);
        },
        onError: () => {
          setSearchResult({});
        },
      },
    );
  };

  const handleNavigate = async () => {
    try {
      await UNAUTHORIZE_USER();
      localStorage.removeItem('userName');
      if (queryClient) queryClient.clear();
    } catch (error) {
      console.log('error::', error);
    }
  };

  const handleLanguage = async (value) => {
    setLanguage(value);
    i18n.changeLanguage(value);
  };

  return (
    <CustomHeader
      isAppDrawerOpen={isAppDrawerOpen}
      onAppDrawerToggle={onAppDrawerToggle}
      handleLogout={handleNavigate}
      handleLanguage={handleLanguage}
      language={language}
      string2={t('string2')}
      header={{
        string1: (
          <Trans
            i18nKey={'header.string1'}
            components={{
              changelog_link: <Styles.ChangelogLink to={navLinks.changelog.link} target="_blank" />,
              text: <Styles.Text />,
            }}
            values={{
              version: version,
              username: username,
              release_date: moment(releasedDate).format('MMMM DD, YYYY'),
            }}
          />
        ),
        string2: t('header.string2'),
        string4: t('header.string4'),
        string8: t('header.string3'),
      }}
      SocialMediaLink={Styles.SocialMediaLink}
      Heading6={H6}
      navLinks={navLinks}
      languageArray={languageArray}
      AccountLabel={Styles.AccountLabel}
      TriggerContainer={Styles.TriggerContainer}
      HeaderSC={Styles.HeaderSC}
      LeftHeader={Styles.LeftHeader}
      Para={Styles.Para}
      RightHeader={Styles.RightHeader}
      SearchBar={
        searchResult?.results_found === '1' && (
          <Styles.SearchContainer style={{ maxHeight: window.innerHeight - 100 }}>
            {Object.keys(searchResult).map((key, i) => (
              <>
                {key === 'results_found' ? null : (
                  <Styles.SearchCategory key={i}>
                    <H6>{searchResult[key]?.results.length > 0 && searchResult[key].description_en}</H6>
                    {searchResult[key]?.results?.map((item, i) => (
                      <Link
                        key={i}
                        className="link-description"
                        to={`${item.url}`}
                        onClick={(event) => {
                          if (!event.ctrlKey) {
                            setSearch('');
                            setSearchResult({});
                          }
                        }}
                      >
                        <Icon name="circle" />
                        <P>{item.search_term_en}</P>
                      </Link>
                    ))}
                  </Styles.SearchCategory>
                )}
              </>
            ))}
          </Styles.SearchContainer>
        )
      }
      isAdmin={true}
      handleChangeSearch={handleChangeSearch}
      search={search}
      desktopSize={desktopSize}
    />
  );
};
export default Header;
